module.exports = __webpack_public_path__ + "img/红包.37a737e0.png";